import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Grid,
  Modal,
  ModalContent,
  ModalOverlay,
  Spinner,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { useDeleteLabTestCategory, useLabTestCategories } from "api/categories";
import { useLabTests } from "api/tests";
import Discount from "classes/discount";
import PageTitle from "generics/PageTitle";
import ToolbarPortal from "generics/ToolbarPortal";
import React, { useMemo, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { DiscountSection } from "../discounts/DiscountPage";
import AddTestCategory from "./AddTestCategory";

export default function CategoriesPage() {
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [selectedDiscount, setSelectedDiscount] = useState<any>();
  const [action, setAction] = useState();
  const addCategory = useDisclosure();
  const labCatgories = useLabTestCategories();
  const testCategories = labCatgories.data ?? [];

  function renderCategories() {
    if (labCatgories.isLoading)
      return (
        <Center>
          <Spinner></Spinner>
        </Center>
      );
    else if (testCategories && !testCategories?.length)
      return (
        <Text textAlign="center" color="gray.500" fontSize="xl">
          No categories
        </Text>
      );

    return (
      <Grid
        templateColumns="repeat(auto-fit, minmax(320px, 1fr))"
        gap={6}
        wrap="wrap"
      >
        {testCategories?.length !== 0 && (
          <Table>
            <Thead
              fontSize="16px"
              fontWeight="600"
              borderBottom="1px solid"
              borderColor="border.500"
            >
              <Tr>
                <Td>NAME</Td>
                <Td>DESCRIPTION</Td>
                <Td>TESTS</Td>
                <Td>FEE</Td>
                <Td> </Td>
              </Tr>
            </Thead>
            <Tbody>
              {testCategories?.map((category: any, index: number) => {
                return (
                  <LabCategoryCard
                    key={index}
                    labCategory={category}
                    setSelectedCategory={setSelectedCategory}
                    setShowDetails={setShowDetails}
                    setSelectedDiscount={setSelectedDiscount}
                    setAction={setAction}
                    addCategory={addCategory}
                  ></LabCategoryCard>
                );
              })}
            </Tbody>
          </Table>
        )}
      </Grid>
    );
  }

  return (
    <Box padding={8}>
      <ToolbarPortal>
        <Flex justifyContent="space-between" alignItems="center">
          <PageTitle flexGrow={1}>Categories</PageTitle>
          <Stack direction="row" alignItems="stretch">
            <Button
              onClick={addCategory.onOpen}
              color="white"
              align="center"
              leftIcon={<FaPlus></FaPlus>}
            >
              Add Category
            </Button>
          </Stack>
        </Flex>
      </ToolbarPortal>
      <DeleteCategoryModal
        selectedCategory={selectedCategory}
        action={action}
        onClose={() => {
          setSelectedCategory(undefined);
          setAction(undefined);
        }}
      ></DeleteCategoryModal>
      {renderCategories()}
      <AddTestCategoryModal
        onClose={addCategory.onClose}
        isOpen={addCategory.isOpen}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        setAction={setAction}
      ></AddTestCategoryModal>
      <Modal
        isOpen={!action && selectedCategory}
        onClose={() => {
          setSelectedCategory(undefined);
          setSelectedDiscount(undefined);
        }}
      >
        <ModalOverlay></ModalOverlay>
        <ModalContent bg="white" borderRadius="4px" maxW="50vw">
          <Box>
            <Box>
              {!selectedCategory ? (
                <Center w="100%" h="100%">
                  <Spinner size="lg" />
                </Center>
              ) : (
                <DiscountSection
                  editDiscount={(discount: Discount) => {
                    setSelectedDiscount(discount);
                    setShowDetails(false);
                  }}
                  onClose={() => {
                    setSelectedCategory(undefined);
                  }}
                  discount={selectedDiscount}
                  category={selectedCategory}
                  showDiscounts={showDetails}
                ></DiscountSection>
              )}
            </Box>
          </Box>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export function getCategoryFee(category: any, labTests: any) {
  if (category.fee) {
    return category.fee;
  }
  const labTestOfCategory = labTests?.filter((test: any) =>
    test.categories.includes(category.id)
  );
  const fee = labTestOfCategory?.reduce((prev: any, curr: any): any => {
    prev += +curr.fee ?? 0;
    return prev;
  }, 0);
  return fee;
}

function LabCategoryCard({
  labCategory,
  setSelectedCategory,
  setShowDetails,
  setSelectedDiscount,
  setAction,
  addCategory,
}: {
  labCategory: any;
  setSelectedCategory: Function;
  setShowDetails: Function;
  setSelectedDiscount: Function;
  setAction: Function;
  addCategory: any;
}) {
  const labTests = useLabTests();
  const labTestIds = useMemo(() => {
    if (labTests.data) {
      return labTests.data.map((test) => test.parentId);
    } else return [];
  }, [labTests.data]);

  return (
    <Tr textAlign="center" verticalAlign="top" pointer="cursor">
      <Td align="char">
        <Text fontSize="sm" color="settingText.500" fontWeight="500">
          {labCategory?.name}
        </Text>
      </Td>
      <Td>
        <Text fontSize="sm" color="settingText.500" fontWeight="400">
          {labCategory?.description}
        </Text>
      </Td>
      <Td>
        <Text fontSize="sm" color="settingText.500" fontWeight="400">
          {labCategory?.tests
            .map((test: any) => {
              if (labTestIds.includes(test)) {
                return labTests.data?.find((t) => t.parentId === test)?.name;
              }
              return "";
            })
            .filter((id: any) => id)
            .join(", ")}
        </Text>
      </Td>
      <Td>
        <Text fontSize="sm" color="settingText.500" fontWeight="400">
          {getCategoryFee(labCategory, labTests.data)}
        </Text>
      </Td>
      <Td>
        <Flex>
          <Flex direction="column">
            <Button
              cursor="pointer"
              margin="2"
              padding="0px"
              onClick={() => {
                setSelectedDiscount(new Discount({}));
                setShowDetails(false);
                setSelectedCategory(labCategory);
              }}
              boxShadow="0px 4px 14px 0px rgba(0, 0, 0, 0.13)"
            >
              <Text padding={"1px 8px"} fontSize="10px" fontWeight="700">
                Add Discount
              </Text>
            </Button>
            <Button
              cursor="pointer"
              margin="2"
              padding="0px"
              onClick={() => {
                setShowDetails(true);
                setSelectedCategory(labCategory);
              }}
              boxShadow="0px 4px 14px 0px rgba(0, 0, 0, 0.13)"
            >
              <Text padding={"1px 8px"} fontSize="10px" fontWeight="700">
                View Discounts
              </Text>
            </Button>
          </Flex>

          {labCategory.customPackage ? (
            <Flex direction="column">
              <Button
                cursor="pointer"
                margin="2"
                padding="0px"
                onClick={() => {
                  setAction("edit");
                  addCategory.onOpen();
                  setSelectedCategory(labCategory);
                }}
                boxShadow="0px 4px 14px 0px rgba(0, 0, 0, 0.13)"
              >
                <Text padding={"1px 8px"} fontSize="10px" fontWeight="700">
                  Edit
                </Text>
              </Button>
              <Button
                cursor="pointer"
                margin="2"
                padding="0px"
                background="error.500"
                onClick={() => {
                  setAction("delete");
                  setSelectedCategory(labCategory);
                }}
                boxShadow="0px 4px 14px 0px rgba(0, 0, 0, 0.13)"
              >
                <Text padding={"1px 8px"} fontSize="10px" fontWeight="700">
                  Delete
                </Text>
              </Button>
            </Flex>
          ) : null}
        </Flex>
      </Td>
    </Tr>
  );
}

function AddTestCategoryModal({
  isOpen,
  onClose,
  selectedCategory,
  setSelectedCategory,
  setAction,
}: any) {
  const cancelRef = React.useRef<any>();
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={() => {
        onClose();
        setSelectedCategory(undefined);
        setAction(undefined);
      }}
    >
      <AlertDialogOverlay></AlertDialogOverlay>
      <AlertDialogContent maxW="50vw" minW="512px">
        <AlertDialogHeader
          bg="modalHeader.500"
          color="white"
          borderTopRadius="4px"
        >
          {selectedCategory
            ? `Update ${selectedCategory?.name}`
            : "Add New Category"}
        </AlertDialogHeader>
        <AlertDialogCloseButton
          color="richText.500"
          fontSize="14"
        ></AlertDialogCloseButton>
        <AlertDialogBody>
          <AddTestCategory
            onCancel={onClose}
            selectedCategory={selectedCategory}
            setCategory={setSelectedCategory}
          ></AddTestCategory>
        </AlertDialogBody>
        <Divider></Divider>
      </AlertDialogContent>
    </AlertDialog>
  );
}

function DeleteCategoryModal({
  onClose,
  selectedCategory: category,
  action,
}: any) {
  const [deleteLabTestCategory, deleteLabTestCategoryInfo] =
    useDeleteLabTestCategory();

  const cancelRef = React.useRef<any>();
  async function onSubmit() {
    await deleteLabTestCategory(category.id);
    onClose();
  }

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={category && action === "delete"}
    >
      <AlertDialogOverlay />
      <AlertDialogContent maxW="50vw">
        <Flex direction="column">
          <AlertDialogHeader bg="white" color="black" borderTopRadius="4px">
            Delete {category?.name}
          </AlertDialogHeader>
          <AlertDialogCloseButton color="richText.500" fontSize="14" />
          <Divider color="border.500" height="2px"></Divider>
          <AlertDialogBody marginY={4}>
            <Text size="sm" color="settingText.500">
              Are you sure you want to delete this category. Once you delete it
              you will not be able to get it back.
            </Text>
          </AlertDialogBody>
          <Divider></Divider>
          <AlertDialogFooter>
            <Button
              bg="red.300"
              onClick={onSubmit}
              isLoading={deleteLabTestCategoryInfo.isLoading}
            >
              Delete
            </Button>
            <Button
              ml={3}
              variant="outline"
              border="2px"
              borderColor="border.500"
              ref={cancelRef}
              onClick={onClose}
            >
              Cancel
            </Button>
          </AlertDialogFooter>
        </Flex>
      </AlertDialogContent>
    </AlertDialog>
  );
}
